const sessionKey = '_fwnthrdptyfwvs';
const lastActivityStoreKey = '_fwnthrdptyfwvactvt';
let sessionStore = {}; // { session }
let lastActivityStore = {}; // {[widget_id]: Date()}
const storageType = 'localStorage';
// Storage helper
const storage = {
    getItem: (key) => {
        try {
            return window[storageType] && window[storageType].getItem(key);
        }
        catch (error) {
            // Pass silently
        }
    },
    setItem: (key, value) => {
        try {
            window[storageType] && window[storageType].setItem(key, value);
        }
        catch (error) {
            // Pass silently
        }
    },
};
export const getStoredSession = () => {
    let stored = sessionStore;
    try {
        // Skip reading for now
        stored = JSON.parse(storage.getItem(sessionKey));
    }
    catch (error) {
        // Pass silently
    }
    return stored;
};
// eslint-disable-next-line no-unused-vars
export const setSession = (session) => {
    try {
        sessionStore = session;
        storage.setItem(sessionKey, JSON.stringify(session));
    }
    catch (error) {
        // Pass silently
    }
};
export const clearSession = () => {
    try {
        sessionStore = {};
        storage.setItem(sessionKey, JSON.stringify(sessionStore));
    }
    catch (error) {
        // Pass silently
    }
};
export const getStoredLastActivity = () => {
    let stored;
    try {
        stored = storage.getItem(lastActivityStoreKey);
        stored = JSON.parse(stored);
        stored = new Date(stored);
    }
    catch (error) {
        stored = undefined;
    }
    return stored || lastActivityStore;
};
export const setStoredLastActivity = (value) => {
    try {
        lastActivityStore = value;
        storage.setItem(lastActivityStoreKey, JSON.stringify(lastActivityStore));
    }
    catch (error) {
        // Pass silently
    }
};
export const getLastActivity = () => getStoredLastActivity();
export const setLastActivity = () => setStoredLastActivity(new Date());
